import { connectColors } from '@/theme/colors';
import { Button } from '@lego/connect-components-react';
import { Flex, Text } from '@lego/klik-ui';
import type { MRT_TableInstance } from 'material-react-table';

type FilterStatusProps<T extends Record<string, unknown>> = {
  table: MRT_TableInstance<T>;
};

export const FilterStatus = <T extends Record<string, unknown>>({
  table,
}: FilterStatusProps<T>) => {
  const filterCount = table.getState().columnFilters.length;

  if (filterCount > 0) {
    return (
      <Flex gap="4px" alignItems="center">
        <Text
          className="label-sm-medium"
          color={connectColors.core.slate[900]}
          whiteSpace="nowrap"
        >
          {filterCount} {filterCount === 1 ? 'filter' : 'filters'} applied
        </Text>
        <Button
          appearance="ghost"
          size="small"
          onClick={() => table.resetColumnFilters()}
          iconName="control-close"
        >
          Clear all filters
        </Button>
      </Flex>
    );
  }

  return (
    <Text
      className="label-sm-medium"
      color={connectColors.core.slate[900]}
      whiteSpace="nowrap"
    >
      No filters applied
    </Text>
  );
};
